export enum ENavParamsResources {
    home = 1,
    gmap = 2,       
    login = 3,  
    marketplaceBrowse = 4,
    marketplaceContent = 5,
    support = 6,
    validate = 7
}
